import router from "src/routes/routes";
import { createCrudService } from "./crudFactory";
import CommonAPIService from "./commonHandler";

const api = new CommonAPIService(router);

const customRoutes = [];

const baseService = createCrudService("documentAcknowledgments", customRoutes, router);

export const documentAcknowledgmentsService = {
  ...baseService,

  acknowledge: (documentId) =>
    api.postCall(`/api/documentAcknowledgments/${documentId}/acknowledge`),

  getByClient: (clientId, category = "SupportStrategy") =>
    api.getCall(`/api/documentAcknowledgments/client/${clientId}?category=${category}`),

  checkClockInRequirements: (caregiverId, clientId) =>
    api.getCall(`/api/documentAcknowledgments/clock-in-check/${caregiverId}/${clientId}`),
};
